const CoinbaseWalletIcon = props => (
  <svg viewBox="0 0 150 150" x="0px" y="0px" {...props}>
    <g id="Layer_5">
      {' '}
      <g>
        {' '}
        <path
          d="M75,1C34.1,1,1,34.1,1,75s33.1,74,74,74s74-33.1,74-74S115.9,1,75,1z M75,118.3c-23.9,0-43.3-19.4-43.3-43.3 S51.1,31.7,75,31.7s43.3,19.4,43.3,43.3S98.9,118.3,75,118.3z"
          fill="#2B65FB"
        />{' '}
        <path
          d="M85.5,88.9H64.5c-1.8,0-3.3-1.5-3.3-3.3V64.5c0-1.8,1.5-3.3,3.3-3.3h21.1c1.8,0,3.3,1.5,3.3,3.3v21.1 C88.9,87.4,87.4,88.9,85.5,88.9z"
          fill="#2059EB"
        />{' '}
      </g>{' '}
    </g>{' '}
  </svg>
)
export default CoinbaseWalletIcon
